export var ChatButtonElementId;
(function (ChatButtonElementId) {
    ChatButtonElementId["Disabled"] = "chat-button-disabled";
    ChatButtonElementId["Enabled"] = "chat-button";
})(ChatButtonElementId || (ChatButtonElementId = {}));
export const DEFAULT_DISABLED_PROPS = {
    id: ChatButtonElementId.Disabled,
    ['aria-label']: 'Chat currently not available',
    disabled: true,
};
export const DEFAULT_ENABLED_PROPS = {
    id: ChatButtonElementId.Enabled,
    ['aria-label']: 'Open chat',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2hhdEJ1dHRvbi5jb25maWcuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9WaWRlb0NvbnN1bHRhdGlvbi9NZWV0aW5nVmlkZW9Db250YWluZXIvQ2hhdEJ1dHRvbi5jb25maWcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBR0EsTUFBTSxDQUFOLElBQVksbUJBR1g7QUFIRCxXQUFZLG1CQUFtQjtJQUM3Qix3REFBaUMsQ0FBQTtJQUNqQyw4Q0FBdUIsQ0FBQTtBQUN6QixDQUFDLEVBSFcsbUJBQW1CLEtBQW5CLG1CQUFtQixRQUc5QjtBQUVELE1BQU0sQ0FBQyxNQUFNLHNCQUFzQixHQUFzQztJQUN2RSxFQUFFLEVBQUUsbUJBQW1CLENBQUMsUUFBUTtJQUNoQyxDQUFDLFlBQVksQ0FBQyxFQUFFLDhCQUE4QjtJQUM5QyxRQUFRLEVBQUUsSUFBSTtDQUNmLENBQUM7QUFFRixNQUFNLENBQUMsTUFBTSxxQkFBcUIsR0FBc0M7SUFDdEUsRUFBRSxFQUFFLG1CQUFtQixDQUFDLE9BQU87SUFDL0IsQ0FBQyxZQUFZLENBQUMsRUFBRSxXQUFXO0NBQzVCLENBQUMifQ==